import i18n from '@/i18n';
/** 扩图倍数（type=1）· 自定义范围 */
export const OUTPAINT_SCALE_MIN = 1.01;
export const OUTPAINT_SCALE_MAX = 10;

/**
 * 将倍数钳制到合法区间。
 * @param {number|string} raw
 * @returns {number}
 */
export function clampOutpaintScale(raw) {
  const n = Number(raw);
  if (!Number.isFinite(n)) {
    return 1.5;
  }
  if (n < OUTPAINT_SCALE_MIN) {
    return OUTPAINT_SCALE_MIN;
  }
  if (n > OUTPAINT_SCALE_MAX) {
    return OUTPAINT_SCALE_MAX;
  }
  return n;
}

/**
 * 校验扩图倍数（自定义或提交前）。
 * @param {number|string} scale
 * @returns {string|null}
 */
export function validateOutpaintScale(scale) {
  const n = Number(scale);
  if (!Number.isFinite(n) || n <= 1) {
    return i18n.t('workbench:ipeUtilError.outpaintScaleGt1');
  }
  if (n < OUTPAINT_SCALE_MIN || n > OUTPAINT_SCALE_MAX) {
    return i18n.t('workbench:ipeUtilError.outpaintScaleRange', { min: OUTPAINT_SCALE_MIN, max: OUTPAINT_SCALE_MAX });
  }
  return null;
}
